/* eslint-disable */
const ua = window.navigator.userAgent;

export default { 
  isInWeixin: function () {
    return /MicroMessenger/i.test(ua);
  },

  isInAndroidApp: function () {
    return /MedLincAppAndroid/i.test(ua);
  },
  isInIOSApp: function () {
    return /MedLincAppIOS/i.test(ua);
  },
  isInApp: function () {

    return /MedLincApp/i.test(ua);
  },
  isInAndroid: function () {
    return /android/i.test(ua);
  },
  isInIOS: function () {
    return /iPhone/i.test(ua);
  },
  getAppVersion: function () {
    var result = /MedLincApp(?:IOS|Android)\/(\d+[.]\d+([.]\d+)?)/.exec(ua);
    if (result) {
      return result[1];
    } else {
      return '0.0.0';
    }
  }
};

// export default browserEnv;